import type { IconData } from '@stacksjs/iconify-core'

export const coffeeCupF: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M0 0h17a3 3 0 0 1 0 6h-1.252A8 8 0 0 1 0 4zm16 4h1a1 1 0 0 0 0-2h-1z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default coffeeCupF
